const relations = [
  { label: 'Spouse', value: 'spouse' },
  { label: 'Caregiver', value: 'caregiver' },
  { label: 'Foster Child', value: 'foster_child' },
  { label: 'Grandchild', value: 'grandchild' },
  { label: 'Guardian', value: 'guardian' },
  { label: 'Grandparent', value: 'grandparent' },
  { label: 'Sibling', value: 'sibling' },
  { label: 'Child', value: 'child' },
  { label: 'Stepchild', value: 'stepchild' },
  { label: 'Parent', value: 'parent' },
  { label: 'Other', value: 'other' },
];

export default relations;
